var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 20.8078C15.799 25.4519 8.20101 25.4519 3.51472 20.8078C-1.17157 16.1637 -1.17157 8.63421 3.51472 3.99013C8.20101 -0.653938 15.799 -0.653938 20.4853 3.99013C25.1716 8.63421 25.1716 16.1637 20.4853 20.8078Z",
    fill: "url(#paint0_radial_1632_2312)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1632_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.12 17.799C11.06 17.799 10.1 17.569 9.24001 17.109C8.39001 16.639 7.72001 15.994 7.23001 15.174C6.75001 14.354 6.51001 13.429 6.51001 12.399C6.51001 11.369 6.75501 10.444 7.24501 9.62402C7.73501 8.80402 8.40501 8.16402 9.25501 7.70402C10.115 7.23402 11.075 6.99902 12.135 6.99902C12.995 6.99902 13.78 7.14902 14.49 7.44902C15.2 7.74902 15.8 8.18402 16.29 8.75402L15.03 9.93902C14.27 9.11902 13.335 8.70902 12.225 8.70902C11.505 8.70902 10.86 8.86902 10.29 9.18902C9.72001 9.49902 9.27501 9.93402 8.95501 10.494C8.63501 11.054 8.47501 11.689 8.47501 12.399C8.47501 13.109 8.63501 13.744 8.95501 14.304C9.27501 14.864 9.72001 15.304 10.29 15.624C10.86 15.934 11.505 16.089 12.225 16.089C13.335 16.089 14.27 15.674 15.03 14.844L16.29 16.044C15.8 16.614 15.195 17.049 14.475 17.349C13.765 17.649 12.98 17.799 12.12 17.799Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5523 17.5335C15.2998 17.2219 15.9306 16.7689 16.4417 16.1744L16.5656 16.0303L16.4279 15.8992L15.1679 14.6992L15.0202 14.5585L14.8825 14.709C14.1598 15.4982 13.278 15.889 12.225 15.889C11.5352 15.889 10.924 15.7409 10.3868 15.449C9.84846 15.1465 9.43021 14.7325 9.12866 14.2048C8.82763 13.678 8.67501 13.0778 8.67501 12.399C8.67501 11.7202 8.82763 11.1201 9.12866 10.5933C9.43012 10.0657 9.84798 9.65709 10.3856 9.36472L10.3856 9.36474L10.3879 9.36342C10.9251 9.06187 11.5357 8.90902 12.225 8.90902C13.2789 8.90902 14.1609 9.29548 14.8833 10.075L15.0203 10.2227L15.167 10.0847L16.427 8.89971L16.5664 8.76868L16.4417 8.62365C15.931 8.02963 15.3055 7.57649 14.5679 7.26479C13.8305 6.95324 13.0187 6.79902 12.135 6.79902C11.0444 6.79902 10.0511 7.04109 9.15946 7.52832C8.2784 8.00521 7.58193 8.6703 7.07333 9.52143C6.56335 10.3749 6.31001 11.3358 6.31001 12.399C6.31001 13.4615 6.55797 14.4219 7.05741 15.2751L7.0574 15.2751L7.05833 15.2766C7.56677 16.1275 8.26285 16.7972 9.14323 17.284L9.14322 17.2841L9.14568 17.2854C10.0372 17.7622 11.03 17.999 12.12 17.999C13.0034 17.999 13.8151 17.8449 14.5523 17.5335ZM14.5523 17.5335C14.5522 17.5335 14.5521 17.5336 14.5519 17.5336L14.475 17.3491L14.5529 17.5332C14.5527 17.5333 14.5525 17.5334 14.5523 17.5335Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1632_2312",
    x: 6.10999,
    y: 6.59912,
    width: 10.7327,
    height: 12.5999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352083 0 0 0 0 0.704167 0 0 0 0 0.627714 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1632_2312"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1632_2312",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.439 3.22569) rotate(175.672) scale(42.5477 21.1925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573896,
    stopColor: "#6FF2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800531,
    stopColor: "#3AE9D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.342e56ef6292adadd565e06f76c45d38.svg";
export { ForwardRef as ReactComponent };